<template>
	<div class="fade-in mt-16 flex flex-col">
		<span class="text-neutral-900 self-center text-center text-3xl font-bold">
			{{ title }}
		</span>
		<Icon name="mdi:check-circle" class="text-green-500 mt-8 h-32 w-32 self-center" />
		<button
			class="ripple-bg-primary text-white mt-12 w-full rounded-xl px-6 py-5 font-bold"
			@click="emit('submit')"
		>
			{{ btnTitle }}
		</button>
	</div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
	submit: []
}>()
defineProps<{
	title?: string
	btnTitle?: string
}>()
</script>
